import { createFileRoute } from "@tanstack/react-router";
import HighFunctioningDepressionSymptoms from "@/pages/high-functioning-depression/HighFunctioningDepressionSymptoms";
export const Route = createFileRoute(
  "/high-functioning-depression-symptoms-treatment",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "High-Functioning Depression Symptoms & Depression Treatment",
        },
        {
          name: "description",
          content:
            "Still showing up but feeling flat? Learn 10 quiet depression symptoms and how accelerated depression treatment like 5-day SAINT® TMS can help in Coral Springs.",
        },
        {
          property: "og:title",
          content:
            "High-Functioning Depression Symptoms & Depression Treatment",
        },
        {
          property: "og:description",
          content:
            "Still showing up but feeling flat? Learn 10 quiet depression symptoms and how accelerated depression treatment like 5-day SAINT® TMS can help in Coral Springs.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/high-functioning-depression-symptoms-treatment",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/high-functioning-depression-symptoms-treatment",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HighFunctioningDepressionSymptoms />;
}
